import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faYoutube,
  faLinkedin,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

const ICONS: Record<string, IconDefinition> = {
  website: faGlobe,
  instagram: faInstagram,
  instagram2: faInstagram,
  youtube: faYoutube,
  linkedin: faLinkedin,
  facebook: faFacebook,
};

const ICON_COLORS: Record<string, string> = {
  website: "text-gray-500 hover:text-blue-600",
  instagram: "text-pink-500 hover:text-pink-600",
  instagram2: "text-pink-500 hover:text-pink-600",
  youtube: "text-red-500 hover:text-red-600",
  linkedin: "text-blue-600 hover:text-blue-700",
  facebook: "text-blue-500 hover:text-blue-600",
};

interface SocialIconProps {
  href?: string;
  type: string;
}

export default function SocialIcon({ href, type }: SocialIconProps) {
  const icon = ICONS[type];
  if (!icon || !href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={type}
      onClick={(e) => e.stopPropagation()}
    >
      <FontAwesomeIcon
        icon={icon}
        className={`w-5 h-5 ${
          ICON_COLORS[type] || "text-gray-500"
        } transition`}
      />
    </a>
  );
}